// removed by extract-text-webpack-plugin
module.exports = {"softinBlue":"#1668AD"};


//////////////////
// WEBPACK FOOTER
// ./client/assets/styles/main.scss
// module id = 80
// module chunks = 0